<template>
  <b-row class="m-0 pt-1">
    <b-col
      cols="auto"
      class="ml-0 ml-lg-auto text-right pl-3 pr-3 pr-md-3 pr-lg-0 d-flex align-items-center"
    >
      <router-link
        data-testid="button-volver"
        :to="{ name: redireccion }"
        class="text-azul gilmer font-weight-light mb-0"
      >
        <font-awesome-icon icon="arrow-left" class="h5 mb-0" />
        <span class="ml-2">Volver &nbsp;&nbsp;</span>
      </router-link>
    </b-col>
  </b-row>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faArrowLeft);
export default {
  props: ["redireccion"],
  components: {
    FontAwesomeIcon
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/Volver.vue